import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcadmin.request');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-gsdcadmin-request',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcadmin.request/view.scss */
/* src/app/portal.gsdcadmin.request/view.scss: no such file or directory */`],
})
export class PortalGsdcadminRequestComponent implements OnInit {
    public requests: any[] = [];
    public paginatedRequests: any[] = [];
    public loading: boolean = false;
    public role: string = '';  // 역할을 저장할 변수

    public pagination = {
        current: 1,
        start: 1,
        end: 1,
        itemsPerPage: 10
    };
    public total = 0;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/login");

        // 세션에서 role 가져오기
        this.role = this.service.auth.session.role;

        await this.loadRequests();
    }

    public async loadRequests() {
        this.loading = true;
        const { code, data } = await wiz.call('get_all_signup_requests', { page:this.pagination.current });
        if (code != 200) return;
        this.requests = data.requests;
        // this.updatePagination();
        this.pagination.start = Math.floor((this.pagination.current - 1) / 10) * 10 + 1;
        this.pagination.end = data.lastpage;
        this.total = data.total;
        console.log("load : ", this.pagination)
        this.loading = false;
        await this.service.render();
    }

    // 페이지네이션 업데이트
    // public updatePagination() {
    //     this.pagination.start = 1;
    //     this.pagination.end = Math.ceil(this.requests.length / this.pagination.itemsPerPage);
    //     this.paginateData();
    // }

    // // 현재 페이지에 따른 데이터 표시
    // public paginateData() {
    //     const startIdx = (this.pagination.current - 1) * this.pagination.itemsPerPage;
    //     const endIdx = startIdx + this.pagination.itemsPerPage;
    //     this.paginatedRequests = this.requests.slice(startIdx, endIdx);
    //     this.service.render();
    // }

    // 페이지 변경 시 호출
    public async changePage(page: number) {
        console.log("chagePage")
        this.pagination.current = page;
        console.log(this.pagination)
        // this.paginateData();
        await this.service.render();
        await this.loadRequests();
    }


    // 승인 처리 함수
    public async approveRequest(request_id: string) {
        // const isConfirmed = confirm('승인하시겠습니까?');
        const isConfirmed = await this.service.alert.success("승인하시겠습니까?", "취소");
        if (!isConfirmed) return;

        await this.service.loading.show();
        const { code, data } = await wiz.call('approve_request', { request_id });
        await this.service.loading.hide();

        if (code === 200) {
            await this.service.alert.success(typeof data === 'string' ? data : '요청이 승인되었습니다.');
            await this.loadRequests();
        } else {
            // 백엔드가 넘긴 상세 사유(예: SSH 인증 실패)를 그대로 노출
            await this.service.alert.error(typeof data === 'string' ? data : '승인 중 오류가 발생했습니다.');
        }
        await this.service.render();
    }

    // 거절 처리 함수
    public async rejectRequest(request_id: string) {
        // const isConfirmed = confirm('거절하시겠습니까?'); // 거절 확인창
        const isConfirmed = await this.service.alert.error("거절하시겠습니까?", "취소");
        if (!isConfirmed) {
            return; // 사용자가 취소한 경우 요청 중단
        }

        this.loading = true;  // 로딩 시작
        const { code } = await wiz.call('reject_request', { request_id });
        this.loading = false;  // 로딩 종료

        if (code === 200) {
            await this.service.alert.success('요청이 거절되었습니다.');
            await this.loadRequests();  // 요청 목록 새로고침
        } else {
            await this.service.alert.error('거절 중 오류가 발생했습니다.');
        }
        await this.service.render();
    }
}

export default PortalGsdcadminRequestComponent;